import { render } from "./IntegrationCard.vue?vue&type=template&id=1b86e8b7&scoped=true"
import script from "./IntegrationCard.vue?vue&type=script&lang=js"
export * from "./IntegrationCard.vue?vue&type=script&lang=js"

import "./IntegrationCard.vue?vue&type=style&index=0&id=1b86e8b7&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b86e8b7"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
